import React, { useReducer } from 'react';
import AlertContext from 'context/alert/AlertContext';
import AlertReducer from 'context/alert/AlertReducer';
import { SET_ALERT, REMOVE_ALERT } from 'context/types';

const AlertState = props => {
  const initialState = null;

  const [state, dispatch] = useReducer(AlertReducer, initialState);

  // set alert when nothing has been provided in searchbox
  const setAlert = (msg, type) => {
    dispatch({
      type: SET_ALERT,
      payload: { msg: msg, type: type }
    });

    setTimeout(() => dispatch({ type: REMOVE_ALERT }), 3000);
  };

  return (
    <AlertContext.Provider
      value={{
        alert: state,
        setAlert
      }}
    >
      {props.children}
    </AlertContext.Provider>
  );
};

export default AlertState;
